/**
 * Résout un nom de pays en français à partir d'un code ISO-3166-1 alpha-2.
 * Utilise Intl.DisplayNames (natif, dispo sur tous les navigateurs modernes).
 * Fallback : le code lui-même.
 */
let displayNames = null;

function getDisplayNames() {
  if (displayNames) return displayNames;
  try {
    displayNames = new Intl.DisplayNames(['fr'], { type: 'region' });
  } catch {
    displayNames = null;
  }
  return displayNames;
}

export function getCountryName(code) {
  if (!code) return '';
  const upper = code.toUpperCase();
  const namer = getDisplayNames();
  if (!namer) return upper;
  try {
    return namer.of(upper) || upper;
  } catch {
    return upper;
  }
}
